var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"id":"Layer_1","x":"0","y":"0","version":"1.1","viewBox":"0 0 24 24","fill":_vm.iconColor,"xml:space":"preserve"}},[_c('path',{attrs:{"fill":"currentColor","d":"M16 10H4C2.9 10 2 10.9 2 12V19H18V12C18 10.9 17.11 10 16 10M16 14H12V12H16V14M15 9H5V4H15V9M22 7V13H20V7H22M20 15H22V17H20V15Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }